import { BreadcrumContext, ProjectChat } from "@shared/components";
import { gql, useQuery } from "@shared/utils";
import { PropsWithChildren, useMemo } from "react";
import { useProjectVariables } from "../utils/nav";
import { isHeadlessPrintRoute } from "@providers/auth";

export const BreadcrumProvider = ({ children }: PropsWithChildren<any>) => {
  const { project, setProjectId } = useProjectVariables();
  /** Headless PDF render: never fire breadcrumb/chat queries, never mount chat UI. */
  const headless = isHeadlessPrintRoute();
  const items = [
    {
      title: "Projects",
      onClick: () => {
        setProjectId();
      },
    },
  ];
  const memoItems = useMemo(() => items, [items]);
  const projectConfigurationInfo = useQuery<{
    project?: { name: string; _id: string };
  }>(
    gql`
      query Project($project: String!) {
        project(id: $project) {
          _id
          name
        }
      }
    `,
    { variables: { project }, skip: !project || headless }
  );
  if (projectConfigurationInfo?.data?.project) {
    items.push({
      title: projectConfigurationInfo?.data?.project?.name,
      onClick: () => {
        setProjectId(projectConfigurationInfo?.data?.project?._id);
      },
    });
  }
  const value = useMemo(() => {
    return { items: memoItems };
  }, [memoItems]);

  const projectName = projectConfigurationInfo?.data?.project?.name;

  return (
    <BreadcrumContext.Provider value={value}>
      {children}
      {/* Project Chat - only show when viewing a specific project (and never during headless PDF render) */}
      {project && !headless && (
        <ProjectChat
          projectId={project}
          projectName={projectName}
        />
      )}
    </BreadcrumContext.Provider>
  );
};

export default {};
